import dayjs from 'dayjs';
import {
  getMergeUploadedFilesBucketUrl,
  postMergeUploadedFiles,
  postConvertFile,
} from '../../utils/web-apis-client';

export const uploadAction2 = async (
  caseId: string,
  docType: string,
  sortableFiles: any[],
  setCurrentStep: React.Dispatch<React.SetStateAction<string | null>>,
  setCurrentStepIndex: React.Dispatch<React.SetStateAction<number>>,
  vbClaimIds: string[] = [],
) => {
  const fileOrder: string[] = [];

  for await (const file of sortableFiles) {
    const timeStamp = dayjs().unix();
    setCurrentStep(`Processing ${file.name}`);
    setCurrentStepIndex((prev) => prev + 1);
    const response = await getMergeUploadedFilesBucketUrl(
      caseId,
      file.name,
      docType,
      timeStamp.toString(),
    );

    const putResponse = await fetch(response.URL, {
      method: 'PUT',
      headers: {
        'Content-Type': file.contentType,
      },
      body: file.getRawFile?.(),
    });

    if (!putResponse.ok) {
      throw new Error(`Upload failed with status ${putResponse.status}`);
    }

    const convert = await postConvertFile(response.KEY);
    fileOrder.push(convert.file);
  }
  setCurrentStep('Nearly done!');
  return await postMergeUploadedFiles(fileOrder, docType, vbClaimIds).then(
    (response: any) => response.data,
  );
};
